import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const SaveProductDesignMessage = ({ title, cta, children }) => {
  useEffect(() => {
    setTimeout(() => {
      cta();
    }, 10000);
  }, []);

  return (
    <div className="alert alert--success">
      <span className="alert__message">
        { title && (
          <span className="alert__title">{ title }!&nbsp;</span>
        )}
        { children }
      </span>
      <i role="presentation" className="alert__close display-box" onClick={() => cta()} />
    </div>
  );
};

SaveProductDesignMessage.propTypes = {
  title: PropTypes.string.isRequired,
  cta: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};


export default SaveProductDesignMessage;

